import { styled } from '@mui/system'
import { Box, MenuItem, Select, FormControl } from '@mui/material'

export const Wrapper = styled(Box)(`
  display: flex;
  flex-direction: column;
`)

export const SelectWrapper = styled(Box)(({ theme }) => `
  width:100%;
  display:flex;
  flex-direction:column;
  
  & select {
    font-size: 14px;
  }

  & label {
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    color: #000;
  }
`)

export const FormError = styled(Box)(`
  font-size: 0.75rem;
  font-weight: 400;
  margin: 4px 14px 0 14px;
  color: #D14343;
`)

export const FormSelectWrap = styled(FormControl)(({ theme }) => `
  position: relative;

  &.selectWrap label {
    font-weight: 300;
  }

  &.selectWrap .MuiAutocomplete-root label {
    opacity: 0;
  }
  &.selectWrap .MuiAutocomplete-root label.MuiFormLabel-filled {
    opacity: 1;
  }
  
  & .MuiInput-underline:before {
    border-bottom:1px ${theme.components.MuiSelect.styleOverrides.borderColor} solid !important;
  }

  & .MuiInputBase-input {
    font-size:${theme.components.MuiSelect.styleOverrides.fontSize};
  }

  & .formPlaceholder {
    color: ${theme.components.MuiSelect.styleOverrides.placeholderColor} !important;
    -webkit-text-fill-color: ${theme.components.MuiSelect.styleOverrides.placeholderColor} !important;
    -moz-text-fill-color: ${theme.components.MuiSelect.styleOverrides.placeholderColor} !important;
    font-size:${theme.components.MuiSelect.styleOverrides.fontSize};
  }

  & .isDisabled, & .Mui-disabled {
    color: ${theme.components.MuiSelect.styleOverrides.disabledColor} !important;
    -webkit-text-fill-color: ${theme.components.MuiSelect.styleOverrides.disabledColor} !important;
    -moz-text-fill-color: ${theme.components.MuiSelect.styleOverrides.disabledColor} !important;
  }
`)

export const InputLabel = styled(Box)(props => `
  margin-left: 15px;
  margin-bottom: -30px;
  margin-top: 0;
  // opacity: 50%;
  font-size: 12px;
  // z-index: 0;
  // position: absolute;
  // width: fit-content;
  line-height: 40px;
  height: 100%;
  display: flex;
  align-items: center;
`)

export const StyledMenuItem = styled(MenuItem)(props => `
  min-height: auto;
  flex-direction: row;
  padding-left: 20px;
  font-size: 16px;
  white-space: normal;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  & span {
    font-size: 16px;
  }
`)

export const StyledSelect = styled(Select)(props => `
  background: transparent;
  font-size: 16px;
  height: auto;
  & legend{
    width: auto;
  }
  &.MuiOutlinedInput-root{
    &.Mui-disabled {
      background: #F7F7F9 !important;
    }
  }
  & img {
    margin-top: 3px;
    width: 12px;
    right: 13px;
  }
`)

export const FormReq = styled('span')(`
  font-size: 12px;
  color: #DA2A52;
  padding-left:5px;
`)

export const FormLabel = styled('label')(props => `
  text-transform: capitalize;
  font-weight: ${props?.bold ? '600' : '400'};
  color: ${props?.theme?.palette?.primary?.dark || '#333'};
  line-height: 19px;
  width:100%;
  padding-bottom:10px;
`)

export const LabelWrapper = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
`)

export const FormPlaceholder = styled(Box)(`
  color:#ababab;
  position: absolute;
  left: 0;
  top: 5px;
  padding-right: 18px;
  overflow: hidden;
  width: 100%;
  // border: 1px red solid;
  height: auto;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.isLabel {
    top: 20px;
  }
  // &.isDisabled {
  //   color:#dddfe2;
  // }
`)
